import { render, staticRenderFns } from "./discount_examine.vue?vue&type=template&id=4a2da0ea"
import script from "./discount_examine.vue?vue&type=script&lang=js"
export * from "./discount_examine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a2da0ea')) {
      api.createRecord('4a2da0ea', component.options)
    } else {
      api.reload('4a2da0ea', component.options)
    }
    module.hot.accept("./discount_examine.vue?vue&type=template&id=4a2da0ea", function () {
      api.rerender('4a2da0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/dms/views/record_manage/discount_goods_examine/discount_examine.vue"
export default component.exports